import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import '../../css/private/email-api.css';
import SideBar from './../components/SideBar';
import { Select, MenuItem, InputBase, FormControl, InputLabel, Box, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { format } from 'date-fns';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';

const EmailApi = () => {
  
	
  
  const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;
  const CookieAccountName = Cookies.get('current_accountName');
  const CookieAccountId = Cookies.get('current_accountId');
	
  const [FullPageloading, setFullPageloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  
  
  
  const [ApiInput, setApiInput] = useState('');
  
  const [apis, setApis] = useState([]);
  
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const [currentPage, setCurrentPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  
  
  const [ActiveUserName, setActiveUserName] = useState("Eshan");

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  
  const HandleShowModal = () => {
	  
    setShow(true);
	setErrorName("");
	setName("");
    setNameError(false);
    setInputApiArea("true");
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };  
  
const [InputApiArea, setInputApiArea] = useState('true');

const [activeTab, setActiveTab] = useState('Curl'); // Manage active tab
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);
  
  const codeRef = useRef(null);

  const handleCodeClick = () => {
    const range = document.createRange();
    range.selectNodeContents(codeRef.current);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  };
  
  const apiKeyRef = useRef(null);

  const copyApiKey = () => {
    const apiKey = apiKeyRef.current.value;
    navigator.clipboard.writeText(apiKey)
      .then(() => {
		  showSnackbar('API key copied to clipboard!', 'success');
      })
      .catch(err => {
        console.error('Failed to copy API key: ', err);
      });
  };
  
  
  const [Name, setName] = useState('');
  const [NameError, setNameError] = useState(false);
  const [ErrorName, setErrorName] = useState('');
  const NameRef = useRef(null);
  
  const handleGenerate = () =>{
	  
		setErrorName("");
		setNameError(false);
	if (Name.trim() === '') {
		setErrorName("Please give a name to your API");
		setNameError(true);
		NameRef.current.focus();
		return;
	}
	handleAddApi();
  };
  
  // Close dropdown when clicking outside of it
  useEffect(() => {
    document.title = 'Email API | Aadow';
	
	const current_username = CookieAccountId;
	const username = 'testuser';
	const password = 'testpassword';
	const encodedCredentials = btoa(`${username}:${password}`);
	
	const fetchEmailAPIs = async () => {
			try {
			  const response = await fetch(`${ServerApiDomain}/api/emailapi/list?username=${current_username}&page=0`, {
				method: 'GET',
				headers: {
				  'Authorization': `Basic ${encodedCredentials}`,
				  'Content-Type': 'application/json',
				},
			  });

			  if (!response.ok) {
				throw new Error('Network response was not ok');
			  }

			  const data = await response.json();
			  setApis(data.content); // Set the campaigns array
			} catch (error) {
			  setError("Fetch error: " + error.message);
			} finally {
			  setLoading(false); // Set loading to false once data is fetched
			}
	    };
	fetchEmailAPIs();	
  }, []);
  
  
	const current_username = CookieAccountId;
	const username = 'testuser';
	const password = 'testpassword';
	const encodedCredentials = btoa(`${username}:${password}`);
	
	const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
	
	const handleClickOpen = (id) => {
        setSelectedId(id);
        setOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setOpen(false);
        setSelectedId(null);
    };
	
	const handleDelete = async () => {
        try {
            const response = await fetch(`${ServerApiDomain}/api/emailapi/delete?id=${selectedId}&username=${current_username}`, {
                method: 'DELETE',
                headers: {
				  'Authorization': `Basic ${encodedCredentials}`,
                },
            });

            if (response.ok) {
				showSnackbar('API key Removed!', 'success');
                setApis(apis.filter(api => api.id !== selectedId));
            } else {
                alert('Failed to delete the API');
            }
        } catch (error) {
            alert('Error:', error);
        } finally {
            handleCloseDeleteModal();
        }
    };
	
	
	const handleAddApi = async () => {
		setFullPageloading(true);
        try {
            const response = await fetch(`${ServerApiDomain}/api/emailapi/generate?username=${current_username}&name=${Name}`, {
                method: 'POST',
                headers: {
				  'Authorization': `Basic ${encodedCredentials}`,
                },
            });

            if (response.ok) {
                const newApi = await response.json(); // Assuming the API returns the new API object
                setApis([...apis, newApi]); // Add the new API to the list
				
                setInputApiArea("false");
				setApiInput(newApi.api);
				setFullPageloading(false);
            } else {
                console.error('Failed to add the API');
				setFullPageloading(false);
            }
        } catch (error) {
			setFullPageloading(false);
            console.error('Error:', error);
        }
    };
	
  
    const codeSnippets = {
    Curl: `
	curl -X POST https://api.aadow.com/v1/email/request \
	-H "Content-Type: application/json" \
	-d '{
		"api": "YOUR_API_KEY",
		"senderEmail": "YOUR_SENDER_EMAIL",
		"receiverEmail": "YOUR_RECEIVER_EMAIL",
		"subject": "YOUR_EMAIL_SUBJECT",
		"emailContent": "YOUR_EMAIL_CONTENT"
	}'

	`,
    Ruby: `
	require 'net/http'
require 'json'

url = URI("https://api.aadow.com/v1/email/request")
http = Net::HTTP.new(url.host, url.port)
request = Net::HTTP::Post.new(url, {'Content-Type' => 'application/json'})
request.body = {
    api: "YOUR_API_KEY",
    senderEmail: "YOUR_SENDER_EMAIL",
    receiverEmail: "YOUR_RECEIVER_EMAIL",
    subject: "YOUR_EMAIL_SUBJECT",
    emailContent: "YOUR_EMAIL_CONTENT"
}.to_json

response = http.request(request)
puts response.read_body

	`,
    Python: `
	import requests

url = "https://api.aadow.com/v1/email/request"
payload = {
    "api": "YOUR_API_KEY",
    "senderEmail": "YOUR_SENDER_EMAIL",
    "receiverEmail": "YOUR_RECEIVER_EMAIL",
    "subject": "YOUR_EMAIL_SUBJECT",
    "emailContent": "YOUR_EMAIL_CONTENT"
}
headers = {"Content-Type": "application/json"}

response = requests.post(url, json=payload, headers=headers)
print(response.json())

	`,
    PHP: `
	<?php
$url = 'https://api.aadow.com/v1/email/request';
$data = [
    "api" => "YOUR_API_KEY",
    "senderEmail" => "YOUR_SENDER_EMAIL",
    "receiverEmail" => "YOUR_RECEIVER_EMAIL",
    "subject" => "YOUR_EMAIL_SUBJECT",
    "emailContent" => "YOUR_EMAIL_CONTENT"
];

$options = [
    'http' => [
        'header' => "Content-Type: application/json\r\n",
        'method' => 'POST',
        'content' => json_encode($data),
    ],
];

$context = stream_context_create($options);
$response = file_get_contents($url, false, $context);
echo $response;
?>

	`,
    NodeJS: `
	const axios = require('axios');

	const url = "https://api.aadow.com/v1/email/request";
	const data = {
		api: "YOUR_API_KEY",
		senderEmail: "YOUR_SENDER_EMAIL",
		receiverEmail: "YOUR_RECEIVER_EMAIL",
		subject: "YOUR_EMAIL_SUBJECT",
		emailContent: "YOUR_EMAIL_CONTENT"
	};

	axios.post(url, data, { headers: { "Content-Type": "application/json" } })
		.then(response => console.log(response.data))
		.catch(error => console.error(error));
	`,
    Java: `
	import java.io.OutputStream;
	import java.net.HttpURLConnection;
	import java.net.URL;

	public class EmailAPI {
		public static void main(String[] args) throws Exception {
			URL url = new URL("https://api.aadow.com/v1/email/request");
			HttpURLConnection conn = (HttpURLConnection) url.openConnection();
			conn.setRequestMethod("POST");
			conn.setRequestProperty("Content-Type", "application/json");
			conn.setDoOutput(true);

			String jsonInputString = "{"
				+ "\"api\": \"YOUR_API_KEY\","
				+ "\"senderEmail\": \"YOUR_SENDER_EMAIL\","
				+ "\"receiverEmail\": \"YOUR_RECEIVER_EMAIL\","
				+ "\"subject\": \"YOUR_EMAIL_SUBJECT\","
				+ "\"emailContent\": \"YOUR_EMAIL_CONTENT\""
				+ "}";

			try (OutputStream os = conn.getOutputStream()) {
				byte[] input = jsonInputString.getBytes("utf-8");
				os.write(input, 0, input.length);
			}

			System.out.println("Response Code: " + conn.getResponseCode());
		}
	}
	`
  };

  return (
    <SideBar>
	   <Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={FullPageloading}
			>
				<CircularProgress color="inherit" />
		</Backdrop>
      <div className="page-content ">
        <div className="email-api-body ">
        <div className="breadcrumb-area"> 
			 <nav aria-label="breadcrumb">
			  <ol className="breadcrumb">
				<li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
				<li className="breadcrumb-item"><a>API</a></li>
				<li className="breadcrumb-item active" aria-current="page">Email</li>
			  </ol>
			</nav>
		</div>	
		 <div className="header-area">
            <div className="top-area">
              <div className="row align-items-center">
                <div className="col-8">
                  <h1 className="main-heading">Email API</h1>
                  <h6 className="main-subheading">Effortlessly manage and monitor your email APIs for seamless communication and integration.</h6>
                </div>
                <div className="col-4">
                  <button type="button" onClick={HandleShowModal} style={{fontSize: '0.8vw'}} className="primary-button float-end mx-2">Generate a New API Key</button>
                </div>
              </div>
            </div>
          </div>
		  {show && (
			<>
			  <div  style={{position: 'fixed',top: 0,left: 0,width: '100%',height: '100%',backgroundColor: 'rgba(0, 0, 0, 0.5)',zIndex: 1040}}  className="modal-overlay" onClick={handleClose}></div>
			  <div className="modal show d-block" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
				  <div className="modal-content">
					<div className="modal-header w-100">
						<div className="row w-100">
						  <div className="col-11">
							<h5 className="modal-title">Generate a new API Key</h5>
						  </div>
						  <div className="col-1">
							  <a style={{textDecoration: 'none'}} className="close" onClick={handleClose}>
								<span style={{fontSize: '1.2vw', color: 'rgba(100, 100, 100)', cursor: 'pointer'}}>&times;</span>
							  </a>
						  </div>	  
						</div>  
					</div>
					<div className="modal-body py-4 pt-0 px-4">
					{InputApiArea === 'true' && (
						<div className="col-12">
							<label>Name your API key<b className="text-danger">*</b></label>
							<input type="text" ref={NameRef} className={`input-forms w-100 ${NameError ? 'input-error' : ''}`} value={Name} onChange={(e) => {
								  setName(e.target.value);
								}} />
							{ErrorName && <div className="error-message">{ErrorName}</div>}
						</div>
					)}
					{InputApiArea === 'false' && (	
						<div className="col-12 pt-4">
							<p className="api-disclaimer">API key has been generated successfully. Please copy this key and save it somewhere safe. For security reasons, we cannot show it to you again.</p>
							
							<div className="row align-items-center">
							  <div className="col-12">
								<input
								  type="text"
								  className="input-forms"
								  ref={apiKeyRef}
								  readOnly
								  value={ApiInput} 
								  onChange={(e) => setApiInput(e.target.value)}
								/>
							  </div>
							  <div className="col-8 mt-4">
								<button type="button" className="primary-button" onClick={copyApiKey}>
								  <i className="bi bi-copy me-3"></i>Copy API
								</button>
							  </div>
							</div>
						</div>
					)}
						
					</div>
					
					{InputApiArea === 'true' && (
					<div className="modal-footer ">
						<button type="button" className="secondary-button" onClick={handleClose} data-bs-dismiss="modal">Cancel</button>
						<button type="button" className="primary-button" onClick={handleGenerate}>Generate</button>
					</div>
					)}
					
				  </div>
				</div>
			  </div>
			</>
		  )}
		  <div className="table-container">
			<h4 className="your-api-heading">Your API Keys</h4>
			{apis.length === 0 ? (
							<center>
								<div className="empty-error-area">
									<img className="empty-error-image w-25" src="../../iconss/other/no-results.png"  />
									<h2 className="empty-error-heading">No APIs Found</h2>
									<h6 className="empty-error-subheading" >It looks like you don't have any generated APIs at the moment. Create one now to get started!</h6>
								</div>
							</center>
			) : (
			  <table className="styled-table">
				<thead>
				  <tr>
					<th>Version</th>
					<th>API Key</th>
					<th>Name</th>
					<th>Created on</th>
					<th></th>
				  </tr>
				</thead>
				<tbody>
				{apis.map(api => (
				  <tr>
					<td><h5>v3</h5></td>
					<td><h5 className="transaction-date">{'****************' + api.api.slice(-6)}</h5></td>
					<td><h5 className="transaction-amount">{api.name}</h5></td>
					<td><h5 className="transaction-invoice-id">{format(new Date(api.date), 'MMM dd, yyyy')}</h5></td>
					<td><a href="#" className="download-invoice" onClick={() => handleClickOpen(api.id)}><i className="bi bi-trash"></i></a></td>
				  </tr>
				))}  
				</tbody>
			  </table>
			  )}	
			</div>	
		
		<Dialog open={open} onClose={handleCloseDeleteModal}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this API? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteModal} className="text-secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} className="text-danger">
                        Delete
                    </Button>
                </DialogActions>
        </Dialog>
		
		<div className="documentation-area mt-5">
			<div className="row">
				<div className="col-5">
					<h3 className="documentation-heading">About the API</h3>
					<h6 className="documentation-description">The Aadow API makes it simple for developers to seamlessly integrate Aadow's powerful email and messaging features into their applications, enabling smooth automation of promotional and transactional communications.</h6>
					<a  className="documentation-link d-none" href="">Read our API documentation</a>
				</div>
				
				<div className="col-7">
                <div className="code-box">
                  <div className="code-tabs-area">
                    {/* Tab navigation */}
                    {['Curl', 'Ruby', 'Python', 'PHP', 'NodeJS', 'Java'].map(tab => (
                      <a 
                        key={tab} 
                         
                        className={`code-tab ${activeTab === tab ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab)}
                      >
                        {tab}
                      </a>
                    ))}
                  </div>
                  
                  <div className="tab-content-area">
                    {/* Display code based on the active tab */}
                    <pre>
                      <code ref={codeRef} onClick={handleCodeClick}>
                        {codeSnippets[activeTab].trim()}
                      </code>
                    </pre>
                  </div>
                </div>
              </div>
				
			</div>
		</div>
		  
        </div>
      </div>
		  <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
			<MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>{snackbarMessage}</MuiAlert>
		  </Snackbar>
    </SideBar>
  );
};

export default EmailApi;
